import { translations } from "../i18n/translations.jsx";

// Schema of every site text editable in the CMS, grouped by section.
// `area: true` renders a textarea. Paths map onto the translations object.
const stats = [0, 1, 2, 3].flatMap((i) => [
  { path: `about.stats.${i}.value`, label: `Stat ${i + 1} — value` },
  { path: `about.stats.${i}.label`, label: `Stat ${i + 1} — label` },
]);

const serviceItems = [0, 1, 2, 3, 4, 5].flatMap((i) => [
  { path: `services.items.${i}.title`, label: `Service ${i + 1} — title` },
  { path: `services.items.${i}.desc`, label: `Service ${i + 1} — description`, area: true },
  { path: `services.items.${i}.tags`, label: `Service ${i + 1} — tags (comma separated)` },
]);

const sportsAreas = [0, 1, 2, 3, 4, 5].map((i) => ({
  path: `sports.areas.${i}`,
  label: `Area ${i + 1}`,
}));

export const TEXT_SECTIONS = [
  {
    id: "nav",
    label: "Navigation",
    fields: [
      { path: "nav.about" },
      { path: "nav.services" },
      { path: "nav.work" },
      { path: "nav.clients" },
      { path: "nav.letsTalk" },
    ],
  },
  {
    id: "hero",
    label: "Hero",
    fields: [
      { path: "hero.availability" },
      { path: "hero.locations" },
      { path: "hero.role" },
      { path: "hero.tagline", area: true },
      { path: "hero.currentFocus" },
      { path: "hero.currentFocusText", area: true },
      { path: "hero.seeWork" },
    ],
  },
  { id: "marquee", label: "Marquee strip", fields: [{ path: "marquee" }] },
  {
    id: "about",
    label: "About",
    fields: [
      { path: "about.label" },
      { path: "about.headingA", label: "Heading part A" },
      { path: "about.headingB", label: "Heading part B (orange italic)" },
      { path: "about.headingC", label: "Heading part C" },
      { path: "about.headingD", label: "Heading part D (italic)" },
      { path: "about.p1", label: "Paragraph 1", area: true },
      { path: "about.p2", label: "Paragraph 2", area: true },
      { path: "about.p3", label: "Paragraph 3", area: true },
      { path: "about.p4", label: "Paragraph 4 — Awards & recognition", area: true },
      ...stats,
    ],
  },
  {
    id: "services",
    label: "Services",
    fields: [
      { path: "services.label" },
      { path: "services.headingA", label: "Heading part A" },
      { path: "services.headingB", label: "Heading part B (orange italic)" },
      { path: "services.intro", area: true },
      ...serviceItems,
    ],
  },
  {
    id: "sports",
    label: "Sports & Culture",
    fields: [
      { path: "sports.label" },
      { path: "sports.headingA", label: "Heading part A" },
      { path: "sports.headingB", label: "Heading part B (orange italic)" },
      { path: "sports.lead", area: true },
      { path: "sports.areasLabel" },
      ...sportsAreas,
      { path: "sports.thinkingLabel" },
      { path: "sports.thinkingTitle" },
      { path: "sports.thinkingBody", area: true },
    ],
  },
  {
    id: "work",
    label: "Work section",
    fields: [
      { path: "work.label" },
      { path: "work.headingA", label: "Heading part A" },
      { path: "work.headingB", label: "Heading part B (orange italic)" },
      { path: "work.headingC", label: "Heading part C" },
      { path: "work.intro", area: true },
      { path: "work.viewAll" },
    ],
  },
  {
    id: "clients",
    label: "Clients",
    fields: [
      { path: "clients.label" },
      { path: "clients.headingA", label: "Heading part A" },
      { path: "clients.headingB", label: "Heading part B (orange italic)" },
      { path: "clients.intro", area: true },
    ],
  },
  {
    id: "contact",
    label: "Contact",
    fields: [
      { path: "contact.label" },
      { path: "contact.headingA", label: "Heading part A" },
      { path: "contact.headingB", label: "Heading part B (orange italic)" },
      { path: "contact.headingC", label: "Heading part C" },
      { path: "contact.headingD", label: "Heading part D" },
      { path: "contact.headingE", label: "Heading part E (italic)" },
      { path: "contact.dropLine" },
      { path: "contact.primaryCta" },
      { path: "contact.linkedinCta" },
      { path: "contact.studios" },
      { path: "contact.elsewhere" },
      { path: "contact.availability", label: "Availability label" },
    ],
  },
  {
    id: "footer",
    label: "Footer",
    fields: [{ path: "footer.rights" }, { path: "footer.designedIn" }],
  },
];

export function getDefault(path, lang) {
  const value = path.split(".").reduce((o, k) => o?.[k], translations[lang]);
  if (Array.isArray(value)) return value.join(", ");
  return typeof value === "string" ? value : "";
}
